import { useUpdateNotification } from "hooks/useUpdateNotification"

const Versioning = ({ children }) => {
  useUpdateNotification()

  return children
}

export default Versioning
